(() => {
  class ResetPassword {
    constructor($scope, toastr, Auth, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        toastr,
        Auth,
        Notifications
      });

      this.passwordConditions = {
        minLength: false,
        maxLength: false,
        noSpaces: false,
        twoDigits: false,
        oneDigitAtLeastTwo: false,
        oneLetterAtLeastTwo: false,
        twoLetters: false,
        atLeastThreeStatements: false,
        containsLowerCase: false,
        containsUpperCase: false,
        containsSpecialChar: false,
        containsNumbers: false,
      };
    }
    
passwordValidation(password) {
  if (password) {
    const minLength = 8;
    const maxLength = 64;
    const noSpaces = !/\s/.test(password);
    const digitsCount = (password.match(/\d/g) || []).length;
    const lettersCount = (password.match(/[a-zA-Z]/g) || []).length;
    const upperCaseCount = (password.match(/[A-Z]/g) || []).length;
    const lowerCaseCount = (password.match(/[a-z]/g) || []).length;
    const specialCharsCount = (password.match(/[^a-zA-Z0-9]/g) || []).length;
    this.passwordConditions.minLength = password.length >= minLength;
    this.passwordConditions.maxLength = password.length <= maxLength;
    this.passwordConditions.noSpaces = noSpaces;
    this.passwordConditions.twoDigits = digitsCount >= 2;
    this.passwordConditions.twoLetters = lettersCount >= 2;
    this.passwordConditions.oneDigitAtLeastTwo = digitsCount === 1;
    this.passwordConditions.oneLetterAtLeastTwo = lettersCount === 1;
    this.passwordConditions.containsLowerCase = lowerCaseCount > 0;
    this.passwordConditions.containsUpperCase = upperCaseCount > 0;
    this.passwordConditions.containsSpecialChar = specialCharsCount > 0;
    this.passwordConditions.containsNumbers = digitsCount > 1;

    const classCount = 
      (upperCaseCount > 0 ? 1 : 0) +
      (lowerCaseCount > 0 ? 1 : 0) +
      (digitsCount > 0 ? 1 : 0) +
      (specialCharsCount > 0 ? 1 : 0);
    
    this.passwordConditions.atLeastThreeStatements = classCount >= 3;

    return this.passwordConditions.minLength &&
      this.passwordConditions.maxLength &&
      this.passwordConditions.noSpaces &&
      this.passwordConditions.atLeastThreeStatements;
  } else {
    return false;
  }
}

    resetPassword() {
      this.Auth.resetPassword(this.form).then(() => {
        this.toastr.success(this.Notifications.auth.resetPasswordSuccess);
        this.form = {};
        this.$scope.resetForm.$setPristine();
        this.$scope.resetForm.$setUntouched();
      }).catch(() => {
        _.each(err.data.message.summary, errMsg => {
          this.toastr.error(errMsg);
        });
      });
    }

  }

  ResetPassword.$inject = ["$scope", "toastr", "Auth", "Notifications"];
  angular.module('pims').controller('ResetPasswordController', ResetPassword);
})();